import React from 'react';

import {
  DangerBadge,
  DefaultBadge,
  InfoBadge,
  SuccessBadge,
} from '@magoosh/lib/badge';

interface Props {
  status: string;
  text?: string;
}

const StatusBadge: React.FC<Props> = (props) => {
  const badgeComponent = () => {
    if (props.status === 'accepted') {
      return SuccessBadge;
    } else if (props.status === 'finished') {
      return SuccessBadge;
    } else if (props.status === 'passed') {
      return SuccessBadge;
    } else if (props.status === 'pending') {
      return SuccessBadge;
    } else if (props.status === 'rejected') {
      return DangerBadge;
    } else if (props.status === 'processing') {
      return InfoBadge;
    } else if (props.status === 'failed') {
      return DangerBadge;
    } else if (props.status === 'errored') {
      return DangerBadge;
    } else {
      return DefaultBadge;
    }
  };

  const Badge = badgeComponent();

  return (
    <Badge>{props.text || props.status}</Badge>
  );
};

export default StatusBadge;
